"use client";
import { useId } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { createPaginationUrl } from "helpers/url";

import IconArrow from "assets/svg/chevron_left_arrow.svg";

import styles from "./styles.module.css";
import { numberFormatter } from "helpers/number-formatter";

const PaginationWrapper = ({
  total,
  current,
  showFirstItem,
  showLastItem,
  maximumPage,
  listingCount,
  url,
  totalListingLength,
  isEmlakjetLink,
}) => {
  const id = useId();
  const isShowLastPage = current === maximumPage;
  const currentPage = current !== 0 ? current : 1;

  const firstItemUrl = createPaginationUrl({ url, page: 1 });
  const lastItemUrl = createPaginationUrl({ url, page: maximumPage });
  const previousUrl = createPaginationUrl({ url, page: currentPage - 1 });
  const nextUrl = createPaginationUrl({ url, page: currentPage + 1 });
  const leftArrowClasses = classNames({
    [styles.leftArrow]: true,
    [styles.arrowDisabled]: current <= 1,
  });
  const rightArrowClasses = classNames({
    [styles.rightArrow]: true,
    [styles.arrowDisabled]: isShowLastPage || maximumPage < 2,
  });

  const pageCountInfo = () => {
    if (isShowLastPage)
      return `${numberFormatter(totalListingLength - listingCount + 1)} - ${numberFormatter(
        totalListingLength
      )} arasındaki ilanlar listeleniyor.`;
    const startingListing = (currentPage - 1) * listingCount + 1;
    const endListing = Math.min(currentPage * listingCount, totalListingLength);
    return `${numberFormatter(startingListing)} - ${numberFormatter(endListing)} arasındaki ilanlar listeleniyor.`;
  };

  const leftArrowHref = isEmlakjetLink ? `${url}&page=${current - 1}` : previousUrl;
  const rightArrowHref = isEmlakjetLink ? `${url}&page=${current + 1}` : nextUrl;
  const firstItemHref = isEmlakjetLink ? `${url}&page=1` : firstItemUrl;
  const lastItemHref = isEmlakjetLink ? `${url}&page=${maximumPage}` : lastItemUrl;

  const isPaginationWrapperVisible = !!totalListingLength && maximumPage > 1;

  return (
    <>
      {isPaginationWrapperVisible && (
        <div className={styles.wrapper}>
          <ul className={styles.list}>
            <li className={leftArrowClasses}>
              <a href={leftArrowHref}>
                <IconArrow />
              </a>
            </li>
            {showFirstItem && (
              <>
                <li>
                  <a href={firstItemHref}>1</a>
                </li>
                <li>
                  <a href="#" className={styles.passive}>
                    ...
                  </a>
                </li>
              </>
            )}
            {total?.map((item, index) => {
              const itemUrl = createPaginationUrl({ url, page: item });
              return (
                <li key={`${id}+${index}`}>
                  <a
                    href={isEmlakjetLink ? `${url}&page=${item}` : itemUrl}
                    className={classNames({ [styles.selected]: current === item || (current === 0 && item === 1) })}
                  >
                    {item}
                  </a>
                </li>
              );
            })}
            {showLastItem && (
              <>
                <li>
                  <a href="#" className={styles.passive}>
                    ...
                  </a>
                </li>
                <li>
                  <a href={lastItemHref}>{maximumPage}</a>
                </li>
              </>
            )}
            <li className={rightArrowClasses}>
              <a href={rightArrowHref}>
                <IconArrow />
              </a>
            </li>
          </ul>
          <div className={styles.subText}>{pageCountInfo()}</div>
        </div>
      )}
    </>
  );
};

PaginationWrapper.propTypes = {
  total: PropTypes.array,
  current: PropTypes.number,
  showFirstItem: PropTypes.bool,
  showLastItem: PropTypes.bool,
  maximumPage: PropTypes.number,
  pathName: PropTypes.string,
  listingCount: PropTypes.number,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isEmlakjetLink: PropTypes.bool,
  totalListingLength: PropTypes.number,
};

export default PaginationWrapper;
